export default "__VITE_ASSET__DgEwnz1t__"